const RouterBackHandler = () => null;
export default RouterBackHandler;
